@import '../../../theme/mixins';
@import '../../../theme/colors';

.paginationContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .pageSelection {
    @include label1;
    text-align: end;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    margin-left: 10px;

    span {
      margin: 0 2px;
    }

    form {
      min-width: 17px;
      width: fit-content;
      max-width: 20px;
      height: 18px;
      margin: 0;
      margin-left: 2px;

      & > div:first-child {
        margin: 0;
      }

      input {
        @include label1;
        padding: 2px 3px !important;
        text-align: center;
      }
    }
  }

  .pageNumbers {
    display: flex;
    align-items: center;
    margin-left: 20px;

    i {
      color: $oceanBlue;
      font-size: 20px;
    }

    div {
      @include body2;
      width: 21px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span {
      cursor: pointer;
    }

    .paginationControl {
      cursor: pointer;
    }

    .activePage {
      background-color: $oceanBlue;
      color: $white;
    }
  }
}

.pageAmount {
  cursor: pointer;
}

.pageAmountActive {
  @extend .pageAmount;
  background-color: $oceanBlue;
  color: $white;
  width: min-content;
  height: min-content;
  text-align: center;
  font-family: var(--font-family__body);
  font-size: 12px;
  padding: 2px;
}
